import axios from 'axios';
import { ElNotification } from 'element-plus';

/**
 * Configuração base do axios
 */
const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,    
    headers: {
        'Content-Type': 'application/json'
    }
});

/**
 * Interceptador para adicionar o token jwt nas requisições
 */
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Interceptador para tratar respostas da API
 */
api.interceptors.response.use(
    (response) => response, // Para respostas bem-sucedidas, apenas retorna a resposta
    (error) => {
        console.error('[ERROR] ===> ', error)

        if (error.response && error.response.status === 401) {
            ElNotification({
                title: 'Erro na requisição!',
                message: 'Acesso não autorizado!',
                type: 'error'
            });
            
            localStorage.removeItem('token'); 
            window.location.href = '/login';
        }

        if (error.response && error.response.status === 500) {
            ElNotification({
                title: 'Falha na requisição!',
                message: 'Por favor atualize sua página e tente novamente!',
                type: 'error'
            });            
            // localStorage.removeItem('token'); 
            // router.push({ name: 'Login' }); 
        }        

        return Promise.reject(error);
    }
);

export default api;
